import { createStore } from 'vuex'
import api from '../api/login-api'

export default createStore({
	state: {
		isLoggedIn: (localStorage.getItem("berjaya-rpk-session") == null ? false : true),
		session: JSON.parse(localStorage.getItem("berjaya-rpk-session") || "{}"),
		filterLegalGroupModel: JSON.parse(localStorage.getItem("berjaya-rpk-legalgroup") || null as any),
		legalGroups: null as any,
		selectedRpkId: null as any,
		cached: {page: null},
		title: '',
		module: '',
		error: '',
		isSidebarCollapsed: (window.innerWidth < 1024 ? true : false),
		isToolbarCollapsed: false,
		totalApprovalCount: '',
		keyPressedTime: 0,
		countdownTimer: null as ReturnType<typeof setTimeout> | null,
		isRememberMe: false,
		noticeAcknowledged: localStorage.getItem("notice-acknowledged") === "true",
	},
	mutations: {
		title(state, payload) {
			state.title = payload;
		},
		module(state, payload) {
			state.module = payload;
		},
		session(state, payload) {
			state.isLoggedIn = (payload == null ? false : true);
			state.session = payload;
		},
		error(state, error) {
			state.error = error;
		},
		filterLegalGroupModel(state, filterLegalGroupModel) {
			state.filterLegalGroupModel = filterLegalGroupModel;
		},
		isForceUpdatePassword(state, payload) {
			if (state.session != null) {
				state.session.isForceUpdatePassword = payload;
			}
			
			if (localStorage.getItem("berjaya-rpk-session") != null) {
				const obj = JSON.parse(localStorage.getItem("berjaya-rpk-session") || "{}");
				obj.isForceUpdatePassword = payload;
				
				localStorage.setItem("berjaya-rpk-session", JSON.stringify(obj));
			}
		},
		clearCountdownTimer(state) {
			if (state.countdownTimer) {
				clearTimeout(state.countdownTimer);
				state.countdownTimer = null;
			}
		},
		isRememberMe(state, payload) {
			state.isRememberMe = payload;
		},
		noticeAcknowledged(state, payload) {
			localStorage.setItem("notice-acknowledged", payload ? "true" : "false");
			state.noticeAcknowledged = payload;
		},
		setSelectedRpkId(state, payload) {
			state.selectedRpkId = payload;
		},
		removeSelectedRpkId(state) {
			state.selectedRpkId = null;
		}
	},
	actions: {
		setTitleModule({commit}, payload) {
			commit('title', payload.title);
			commit('module', payload.module);
		},
		clearSession({commit}) {
			localStorage.removeItem("berjaya-rpk-session");
			localStorage.removeItem("berjaya-rpk-legalgroup");
			localStorage.removeItem("notice-acknowledged");
			commit('session', null);
			commit('filterLegalGroupModel', null);
			commit("clearCountdownTimer");
		},
		session({commit}) {
			return new Promise((resolve, reject) => {
				api.session()
					.then(response => {
						localStorage.setItem("berjaya-rpk-session", JSON.stringify(response.data));
						commit('session', response.data);
						resolve(response);
					})
					.catch(error => {
						commit('session', null);
						reject(error);
					})
			})
		},
		filterLegalGroupModelSession({commit}, response) {
			if (response == null) {
				localStorage.removeItem("berjaya-rpk-legalgroup");
				commit('filterLegalGroupModel', null);
			}
			
			else {
				localStorage.setItem("berjaya-rpk-legalgroup", JSON.stringify(response));
				commit('filterLegalGroupModel', response);
			}
		},
		loginSession({commit}, response){
			localStorage.setItem("berjaya-rpk-session", JSON.stringify(response.data));
			commit('session', response.data);
		},
		login({commit}, request) {
			return new Promise((resolve, reject) => {
				api.login(request)
					.then(response => {
						resolve(response);
					})
					.catch(error => {
						commit('session', null);
						reject(error);
					})
			})
		},
		logout({commit}) {
			return new Promise((resolve, reject) => {
				api.logout()
				.then(response => {
						localStorage.removeItem("berjaya-rpk-session");
						localStorage.removeItem("notice-acknowledged");
						commit('noticeAcknowledged', false);
						commit('session', null);
						commit("clearCountdownTimer");
						resolve(response);
					})
					.catch(error => {
						commit('session', null);
						reject(error);
					})
			})
		},
		updateIsForceUpdatePassword({commit}, payload) {
			return new Promise((resolve, reject) => {
				commit('isForceUpdatePassword', false);
				resolve(payload);
			})
		},
		updateIsRememberMe({commit}, payload) {
			return new Promise((resolve, reject) => {
				commit('isRememberMe', false);
				resolve(payload)
			})
		},
		startLogoutAlertCountdown({ commit, state }) {
			commit("clearCountdownTimer");
			
			if (state.session != null) {
				state.isRememberMe = state.session.rememberMe 
			}
			
			state.countdownTimer = setTimeout(() => {
				const now = new Date();
				const timeStr = now.toLocaleTimeString();
				alert(`You will be automatically logged out in 10 minutes. \nPlease save your progress before logout \n\nAlert time: ${timeStr}`)
			}, state.isRememberMe ? 28800000 : 1200000);   // 28800000=8H, 86400000=24H, 85800000<>24H, 1200000=20Minutes
		},
		setNoticeAcknowledged({commit}, payload) {
			commit("noticeAcknowledged", payload);
		},
		updateSelectedRpkId({ commit }, value) {
			commit('setSelectedRpkId', value);
		},
		clearSelectedRpkId({ commit }) {
			commit('removeSelectedRpkId');
		}
	},
	getters: {
		isLoggedIn: state => state.isLoggedIn,
		getSession: state => state.session,
		getFilterLegalGroupModel: state => state.filterLegalGroupModel,
		getLegalGroups: state => state.legalGroups,
		getSelectedRpkId: state => state.selectedRpkId,
		getCached: state => state.cached,
		getTitle: state => state.title,
		getModule: state => state.module,
		getError: state => state.error,
		isSidebarCollapsed: state => state.isSidebarCollapsed,
		isToolbarCollapsed: state => state.isToolbarCollapsed,
		getTotalApprovalCount: state => state.totalApprovalCount,
		getKeyPressedTime: state => state.keyPressedTime,
		getNoticeAcknowledged: state => state.noticeAcknowledged,
	}
});